<template>
    <v-stepper v-model="step" style="width:100%">
        <loading-component :value="loading"></loading-component>
        <v-stepper-header>
            <v-stepper-step :complete="step > 1" step="1">Review And Update Time</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="step > 2" step="2">Select Ride To Join With</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="step > 3" step="3">Saved!</v-stepper-step>
        </v-stepper-header>
        <v-stepper-items>
            <v-stepper-content step="1">
                <requests-editor :requests="selectedItems" @updateStepper="updateStepper"/>
            </v-stepper-content>
            <v-stepper-content step="2">
                <choose-ride-component v-model="ride_id" :disabled="loading" @rideSelected="updateStepper"/>
            </v-stepper-content>
            <v-stepper-content step="3">
                <v-card>
                    <v-card-title>
                        Saved And Joined Ride!
                    </v-card-title>
                </v-card>
            </v-stepper-content>
        </v-stepper-items>
    </v-stepper>

</template>

<script>

    import RequestsEditor from "@/components/RequestsEditor";
    import ChooseRideComponent from "@/components/wasilni/input/ChooseRideComponent";
    import LoadingComponent from "@/components/LoadingComponent";

    export default {
        name: "JoinRide",
        components: {ChooseRideComponent, RequestsEditor,LoadingComponent},
        props: {
            selectedItems: {
                type: Array,
                required: true,
            }
        },
        data() {
            return {
                step: 1,
                ride_id: null,
                loading: false
            }
        },
        methods: {
            updateStepper() {
                if (this.step === 2) {
                    this.loading = true;
                    this.axios.put(this.api.ACTIONS.JOIN_RIDE(this.ride_id), {
                        bookings: this.selectedItems.map(item => item.id),
                    }).then(
                        () => {
                            window.getApp.$emit('SHOW_TOAST', "RIDE CREATED!");
                            this.step++;
                            setTimeout(() => this.$emit("close"), 1500);
                        }
                    ).catch(
                        error => {
                            if (error.response.status === 404) {
                                window.getApp.$emit("SHOW_TOAST", "Ride Not Found!", 'orange');
                                this.ride_id = null;
                            } else {
                                window.getApp.$emit('SHOW_TOAST', error.response.status === 400 ? error.response.data.message : 'Error happened Check error log', 'red');
                                console.log(error);
                            }
                        }
                    ).finally(
                        () => this.loading = false
                    );
                } else
                    this.step++;
            }
        },
    }
</script>

<style scoped>

</style>